import { render } from "./MenuTop.vue?vue&type=template&id=d66c7634&scoped=true"
import script from "./MenuTop.vue?vue&type=script&lang=js"
export * from "./MenuTop.vue?vue&type=script&lang=js"

import "./MenuTop.vue?vue&type=style&index=0&id=d66c7634&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66c7634"]])

export default __exports__